import {
  Box,
  Column,
  Radio,
  RadioProps,
  Tooltip,
  TextWithTooltip,
} from "@hightouch/htui";
import { ReactNode, useRef } from "react";

export function RadioCard<T>({
  value,
  label,
  description,
  icon,
}: RadioProps<T> & { label: string; description: string; icon: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const overflowingText = useRef<HTMLDivElement>(null);
  // It isn't possible to put a ref on our Radio component so we need to query for the input
  const isSelected = ref.current?.querySelector("input")?.checked;
  const showTooltip =
    overflowingText.current &&
    overflowingText.current.offsetHeight < overflowingText.current.scrollHeight;

  return (
    <Column
      as="label"
      position="relative"
      borderRadius={6}
      borderWidth={isSelected ? "2px" : "1px"}
      borderColor={isSelected ? "primary.border" : "base.border"}
      boxShadow="sm"
      w="136px"
      h="136px"
      gap={2}
      align="center"
      justify="center"
      cursor="pointer"
      p={2}
      _hover={{ borderColor: "gray.400" }}
    >
      <Box position="absolute" top={0} left={0} p={2} ref={ref}>
        <Radio value={value} label="" description="" />
      </Box>
      {icon}
      <Column textAlign="center" overflow="hidden" width="100%">
        <TextWithTooltip size="md" fontWeight="medium" color="text.primary">
          {label}
        </TextWithTooltip>
        <Tooltip isDisabled={!showTooltip} message={description}>
          <Box
            ref={overflowingText}
            display="-webkit-box"
            overflow="hidden"
            textOverflow="ellipsis"
            color="text.tertiary"
            lineHeight={4}
            sx={{
              textAlign: "center",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {description}
          </Box>
        </Tooltip>
      </Column>
    </Column>
  );
}
